import { getINDStockDomainUrl } from '../api/url-constants'

export const INDSTOCKS_HOST = 'www.indstocks.com'
export const INDGLOBAL_HOST = 'indmoney.global'
export const INDMONEY_HOST = 'www.indmoney.com'
export const INDMONEY_DOMAIN = 'https://www.indmoney.com'
export const IND_STOCKS_DOMAIN = 'https://www.indstocks.com'
export const BETA_INDSTOCKS_HOST = 'beta.indstocks.com'
export const BETA_INDSTOCKS_DOMAIN = 'https://beta.indstocks.com'
export const STENCIL_WARMER_DOMAIN = 'stencil-warmer.indiawealth.in'
export const BETA_INDMONEY_HOST = 'beta.indmoney.com'

export const triadRedirectionBaseUrl = `${getINDStockDomainUrl()}/app`
